import styled from 'styled-components'

import BaseAvatar from 'components/Avatar'

import { truncateStyles } from 'components/Truncate'

export const Container = styled.section`
  display: flex;
  align-items: center;
  margin-left: 5px; /* stylelint-disable-line scales/space */
  overflow: hidden;
`

export const BackgroundWrapper = styled.div`
  padding: 11px 12px; /* stylelint-disable-line scales/space */
  background-color: ${({ theme }) => theme.colors.background.light.secondary};
  border: 0.5px solid ${({ theme }) => theme.colors.border.dark.high}; /* stylelint-disable-line scales/border-width */
  border-radius: 7px;
  box-shadow: ${({ theme }) => theme.shadows.boxShadow.subtle};
`

export const Avatar = styled(BaseAvatar)`
  margin: 0px 8px 0px 0;
`

Avatar.defaultProps = {
  size: '32px',
}

export const Text = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.smaller};
  ${truncateStyles};
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;

  overflow: hidden;
  flex: 1;

  & ${/* sc-selector */ Text}:first-child {
    display: flex;
    align-items: center;

    font-size: 0.875rem;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text.dark.base};
  }

  & ${/* sc-selector */ Text}:last-child {
    font-size: 0.8125rem;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.text.dark.secondary};
  }
`

export const TextOverflow = styled.span`
  ${truncateStyles};
  width: 100%;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`
